import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

const KINDS = [
    { kind: "events", label: "Eventi", path: "/admin/events" },
    { kind: "productions", label: "Produzioni TV", path: "/admin/productions" },
    { kind: "formats", label: "Format TV", path: "/admin/formats" },
    { kind: "talents", label: "Talent & Ospiti", path: "/admin/talents" },
];

export default function AdminDashboard() {
    const [stats, setStats] = useState({});
    const [contacts, setContacts] = useState(0);

    useEffect(() => {
        (async () => {
            const entries = await Promise.all(
                KINDS.map(async (k) => {
                    try {
                        const r = await api.get(`/admin/${k.kind}`);
                        return [k.kind, r.data.length];
                    } catch {
                        return [k.kind, 0];
                    }
                })
            );
            setStats(Object.fromEntries(entries));
            try {
                const c = await api.get("/admin/contacts");
                setContacts(c.data.length);
            } catch {}
        })();
    }, []);

    return (
        <div className="max-w-5xl" data-testid="admin-dashboard">
            <div className="kicker mb-3">N&M CMS</div>
            <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-[-0.03em] mb-10">
                Dashboard
            </h1>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-14">
                {KINDS.map((k) => (
                    <Link
                        key={k.kind}
                        to={k.path}
                        data-testid={`stat-${k.kind}`}
                        className="border border-white/15 p-6 hover:border-[color:var(--brand-blue)] transition-colors group"
                    >
                        <div className="kicker text-white/50">{k.label}</div>
                        <div className="font-display text-5xl font-black mt-2 group-hover:text-[color:var(--brand-blue)] transition-colors">
                            {stats[k.kind] ?? "—"}
                        </div>
                    </Link>
                ))}
            </div>

            <div className="border border-white/15 p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div>
                    <div className="kicker text-white/50 mb-2">Messaggi ricevuti</div>
                    <div className="font-display text-3xl font-bold">{contacts}</div>
                </div>
                <Link to="/admin/contacts" className="btn-ghost text-white" data-testid="dashboard-contacts-cta">
                    Vai ai messaggi →
                </Link>
            </div>

            <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="border border-white/10 p-6">
                    <div className="kicker mb-3">Suggerimento</div>
                    <p className="text-white/70">
                        Usa l'immagine copertina in formato verticale (4:5) per Talent e orizzontale (16:10)
                        per Eventi e Produzioni per un risultato editoriale ottimale.
                    </p>
                </div>
                <div className="border border-white/10 p-6">
                    <div className="kicker mb-3">Pubblicazione</div>
                    <p className="text-white/70">
                        Puoi salvare un contenuto in stato <b>bozza</b> e renderlo visibile al pubblico
                        cambiandolo in <b>pubblicato</b> in qualsiasi momento.
                    </p>
                </div>
            </div>
        </div>
    );
}
